<template>
  <div class="box-item" :style="{'font-size':fontSize+'px'}">
    <template v-for="(item,index) in nums">
      <li :class="{'number-item': !isNaN(item), 'mark-item': isNaN(item) }" :style="{'background-color':backgroundImage?'':backgroundColor,
    'background-image':'url('+backgroundImage+')',
    'border-color':borderColor,
    height:itemHeight+ 'px',
    width:itemWidth+ 'px',
    'margin-right':index<nums.length-1?gap+'px':'0px'}" :key="index">
        <span v-if="!isNaN(item)">
          <i ref="numberItem" :style="{color:color,top:0}">0123456789</i>
        </span>
        <div class="mid-line" :style="{'background-color':borderColor,width:itemWidth+ 'px'}"></div>
      </li>
      <!-- <li class="mark-item" :key="index">
        <span class="comma" :style="{color:borderColor}">,</span>
      </li> -->

    </template>

  </div>
</template>
<script>
export default {
  props: {
    value: {
      type: Number | String,
      default: 0,
    },
    minBit: {
      //最小位数
      type: Number,
      default: 4,
    },
    maxBit: {
      //最大位数
      type: Number,
      default: 6,
    },
    color: {
      type: String,
      default: '#2d7cff',
    },
    points: {
      //数字是否显示分结号
      type: Boolean,
      default: false,
    },
    fontSize: {
      //数字字号
      type: Number,
      default: 54,
    },
    gap: {
      //数字键间隔
      type: Number,
      default: 20,
    },
    backgroundColor: {
      //背景颜色
      type: String,
      default: 'transparent',
    },
    backgroundImage: {
      //背景图片
      type: String,
      default: '',
    },
    borderColor: {
      type: String,
      default: '#6BD8E5',
    },
    itemHeight: {
      //文字高度
      type: Number,
      default: 84,
    },
    itemWidth: {
      //文字宽度
      type: Number,
      default: 58,
    },
  },
  data() {
    return {
      nums: ['0'], // 默认订单总数
    }
  },
  mounted() {
    this.initNumber()
  },
  watch: {
    value(val) {
      this.initNumber()
    },
  },
  computed: {
    numberTop() {
      console.log('(this.itemHeight - this.fontSize) / 4', this.itemHeight - this.fontSize)
      return (this.itemHeight - this.fontSize) / 4 + 'px'
    },
  },
  methods: {
    // 处理数字
    initNumber() {
      let num = this.value.toString()
      if (isNaN(num)) {
        num = 0
      }

      // return
      // 把订单数变成字符串
      if (num.length <= this.minBit) {
        num = num.padStart(this.minBit, '0')

        this.nums = num.split('')

        this.$nextTick(() => {
          this.setNumberTransform()
        })
      } else if (num.length <= this.maxBit) {
        // 订单数中加入逗号
        this.nums = num.split('') // 将其便变成数据，渲染至滚动数组
        // console.log('>>>>>>>>>>>>>>1this.nums', this.nums);
        this.$nextTick(() => {
          this.setNumberTransform()
        })
      } else {
        // 订单总量数字超过八位显示异常
        this.$message.warning('订单总量数字过大，显示异常，请联系客服')
      }
    },

    // 设置文字滚动
    setNumberTransform() {
      // return
      const numberItems = this.$refs.numberItem // 拿到数字的ref，计算元素数量
      const numberArr = this.nums.filter((item) => !isNaN(item))
      // 结合CSS 对数字字符进行滚动,显示订单数量
      for (let index = 0; index < numberItems.length; index++) {
        const elem = numberItems[index]
        elem.style.transform = `translate(-50%, -${numberArr[index] * 10}%)`
      }
    },
  },
}
</script>
<style scoped lang='stylus'>
/* 订单总量滚动数字设置 */
.box-item
  position relative
  // height 100px
  // font-size 54px
  line-height 41px
  text-align center
  list-style none
  writing-mode vertical-lr
  text-orientation upright
  /* 文字禁止编辑 */
  -moz-user-select none /* 火狐 */
  -webkit-user-select none /* webkit浏览器 */
  -ms-user-select none /* IE10 */
  -khtml-user-select none /* 早期浏览器 */
  user-select none
  /* overflow: hidden; */
/* 默认逗号设置 */
.mark-item
  width 10px
  height 100px
  margin-right 5px
  line-height 10px
  font-size 48px
  position relative
  & > span
    position absolute
    width 100%
    bottom 0
    writing-mode vertical-rl
    text-orientation upright
/* 滚动数字设置 */
.number-item
  list-style none
  margin-right 5px
  border-radius 4px
  border 1px solid rgba(221, 221, 221, 1)
  background-size 100% 100%
  background-repeat repeat
  position relative
  & > span
    position relative
    display inline-block
    width 100%
    height 100%
    margin-right 10px
    writing-mode vertical-rl
    text-orientation upright
    overflow hidden
    & > i
      font-style normal
      position absolute
      left 50%
      transform translate(-50%, 0)
      transition transform 1s ease-in-out
      letter-spacing 10px
      background-color transparent
      z-index 2
      font-weight bold
  .mid-line
    height 1px
    position absolute
    top 50%
    left 0
.number-item:last-child
  margin-right 0
</style>



// WEBPACK FOOTER //
// src/components/parts/h-number-flop.vue